import React from "react";

function About() {
  return (
    <section className="section about-section">
      <h1 className="section-title">About Us</h1>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed gravida
        risus a sapien bibendum, sit amet faucibus turpis tincidunt. Fusce quis
        ante nulla. Vestibulum in mi luctus, pulvinar nisl a, molestie arcu.
        Morbi ut lacinia velit. Morbi mattis tellus rutrum tortor sollicitudin,
        vulputate mollis nisl volutpat. Pellentesque ultrices sodales libero, a
        viverra tellus ornare sed. Donec semper sagittis risus, sit amet tempus
        lacus mattis quis. Etiam pharetra lacus nec elit maximus mattis.
      </p>
      <p>
        Nullam ac felis eu augue tincidunt volutpat non in lorem. Nullam nunc
        sem, faucibus ac ex nec, fringilla dignissim ligula. Aliquam augue ex,
        accumsan quis nulla non, vehicula pulvinar nisl. Fusce eu ullamcorper
        erat. Nulla quis massa sapien. Etiam sit amet tincidunt nunc. Praesent
        dolor lacus, vehicula et ex vehicula, blandit consectetur erat. Nam
        commodo sodales mi, nec tempor mi vestibulum ut. Sed vitae justo tempus
        purus iaculis tempor.
      </p>
    </section>
  );
}

export default About;
